import { useContext, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useNavigate } from "react-router-dom";
import "./PatientList.css";
import FavouriteDropdown from "../PatientDetail/Favourite";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Text, LanguageContext } from "../../utils/Language";
import { PatientService, LoginService } from "../../services";

function PatientList(props) {
  const [patientList, setPatientList] = useState([]);
  const navigate = useNavigate();
  const { dictionary } = useContext(LanguageContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  function getStatusText(stateId) {
    if (stateId < 3)
      return dictionary.PatientStatus.Preprocessing
    else if (stateId < 5)
    return dictionary.PatientStatus.Segmentation
    else if (stateId  < 7)
    return dictionary.PatientStatus.Planning
    else if (stateId === 7)
    return dictionary.PatientStatus.DoctorApproval
    else if (stateId < 14)
    return dictionary.PatientStatus.Manufacturing
    else if (stateId === 14)
    return dictionary.PatientStatus.Packaging
    else if (stateId === 16)
    return dictionary.PatientStatus.Shipped
    else return ""
  }

  useEffect(() => {
    PatientService.getPatientList().then((response) => {
      setPatientList(response)
    }
    );

    return () => {};
  }, []);

  function formatItem(item, index) {
    let newItem = {};
    newItem["id"] = item.Id;
    newItem["fav"] = {"patientId": item.Id, "fav": item.Favori}
    newItem["imageurl"] = LoginService.generateImageUrl("TN-" + item.imgURL);
    newItem["name"] =
      item.FamilyName + " " + item.FirstName + " (" + item.PatientCode + ")";
    newItem["date"] = new Date(item.SystemDate).toLocaleDateString();
    newItem["status"] = getStatusText(item.ActionStep);
    return newItem;
  }

  function render_table(num, inProduction) {
    let rawItems = patientList
      .filter((item) => item.Arsiv === num)
      .filter((item) =>
      inProduction
          ? item.ActionStep !== null && item.ActionStep !== 16
          : inProduction === false
            ? item.ActionStep === null || item.ActionStep === 16
            : true
      )
      .sort((a, b) => {
        if (a.PatientCode > b.PatientCode) return -1;
        else if (a.PatientCode < b.PatientCode) return 1;
        else return 0;
      });

    let data = rawItems.map(formatItem);

    // Apply Search Filter
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      data = data.filter((row) => {
        return (
          (row.name && row.name.toLowerCase().includes(q)) ||
          (row.date && row.date.toLowerCase().includes(q)) ||
          (row.status && row.status.toLowerCase().includes(q))
        );
      });
    }

    // Apply Sorting
    if (sortField) {
      data.sort((a, b) => {
        let valA = a[sortField] || "";
        let valB = b[sortField] || "";

        if (sortField === "date") {
          const rawA = rawItems.find((item) => item.Id === a.id);
          const rawB = rawItems.find((item) => item.Id === b.id);
          valA = rawA ? new Date(rawA.SystemDate).getTime() : 0;
          valB = rawB ? new Date(rawB.SystemDate).getTime() : 0;
        } else if (sortField === "name") {
          valA = valA.toString().toLowerCase();
          valB = valB.toString().toLowerCase();
        }

        if (valA < valB) return sortDirection === "asc" ? -1 : 1;
        if (valA > valB) return sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }

    return (
      <div>
        <Row className="p-2" style={{ width: "100%" }}>
          <Col>
            <input
              type="text"
              className="form-control"
              placeholder={dictionary.Search}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Col>
          <Col className="col-6" style={{ textAlign: "right" }}>
            <Link to="/newpatient/new" className="btn btn-primary">
              <Text tid="New Patient" />
            </Link>
          </Col>
        </Row>

        <Table size="sm" striped hover className="react-bootstrap-table mt-2">
          <thead>
            <tr>
              <th style={{ width: "50px" }}></th>
              <th style={{ width: "60px" }}></th>
              <th onClick={() => handleSort("name")} style={{ cursor: "pointer", userSelect: "none" }}>
                {dictionary.PatientName}
                {sortField === "name" ? (
                  sortDirection === "asc" ? <i className="fa fa-sort-up ms-1" /> : <i className="fa fa-sort-down ms-1" />
                ) : (
                  <i className="fa fa-sort text-muted ms-1" style={{ opacity: 0.5 }} />
                )}
              </th>
              <th onClick={() => handleSort("date")} style={{ cursor: "pointer", userSelect: "none" }}>
                {dictionary.Date}
                {sortField === "date" ? (
                  sortDirection === "asc" ? <i className="fa fa-sort-up ms-1" /> : <i className="fa fa-sort-down ms-1" />
                ) : (
                  <i className="fa fa-sort text-muted ms-1" style={{ opacity: 0.5 }} />
                )}
              </th>
              <th>{dictionary.Status}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr
                key={row.id}
                onClick={() => navigate("/patients/" + row.id)}
                style={{ cursor: "pointer" }}
              >
                <td onClick={(e) => e.stopPropagation()}>
                  <FavouriteDropdown fav={row.fav.fav} patientId={row.fav.patientId} />
                </td>
                <td>
                  <Image src={row.imageurl} width={30} fluid />
                </td>
                <td>{row.name}</td>
                <td>{row.date}</td>
                <td>{row.status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  function render_tab(tabName, archiveNum, inProduction) {
    const numOfItems = patientList
      .filter((item) => item.Arsiv === archiveNum)
      .filter((item) =>
      inProduction
          ? item.ActionStep !== null && item.ActionStep !== 16
          : inProduction === false
            ? item.ActionId === null || item.ActionStep === 16
            : true
      ).length;

    const disabled = numOfItems === 0;
    return (
      <Tab
        eventKey={archiveNum + inProduction}
        disabled={disabled}
        title={`${tabName} (${numOfItems})`}
      >
        {render_table(archiveNum, inProduction)}
      </Tab>
    );
  }
  return (
    <Container>
      <Tabs defaultActiveKey="0true" id="tab-control" className="mb-3">
        {render_tab(dictionary.InProduction, "0", true)}
        {render_tab(dictionary.InTreatment, "0", false)}
        {render_tab(dictionary.ActionRequired, "1")}
        {render_tab(dictionary.Archieved, "5")}
      </Tabs>
    </Container>
  );
}

export default PatientList;
